module.exports = __webpack_public_path__ + "img/coming-soon-dark.aa918bd6.svg";